import { render } from "./SegmentsSelect.vue?vue&type=template&id=f2bc0674&scoped=true&lang=pug"
import script from "./SegmentsSelect.vue?vue&type=script&lang=js"
export * from "./SegmentsSelect.vue?vue&type=script&lang=js"

import "./SegmentsSelect.vue?vue&type=style&index=0&id=f2bc0674&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2bc0674"]])

export default __exports__